import axios from "axios";
import AlertService from "./alertService";
import store from "../store";
import MainService from "./mainService";
import { setToken } from "../store/reducers/UserReducer";
import { ERROR_KEY } from "./constants";

let isRefreshing = false;

const api = axios.create({
	baseURL: process.env.REACT_APP_API,
	headers: {
		"ngrok-skip-browser-warning": true,
		"Content-Type": "application/json",
	},
	maxRedirects: 0,
	withCredentials: true,
});

const identityApi = axios.create({
	baseURL: process.env.REACT_APP_IDENTITY_API,
	headers: {
		"ngrok-skip-browser-warning": true,
	},
});

identityApi.interceptors.request.use(async config => {
	config.headers = {
		"ngrok-skip-browser-warning": true,
		Authorization: localStorage.getItem("token")
			? `Bearer ${localStorage.getItem("token")}`
			: "",
	};
	return config;
});

api.interceptors.request.use(async config => {
	config.headers = {
		"ngrok-skip-browser-warning": true,
		Authorization: localStorage.getItem("token")
			? `Bearer ${localStorage.getItem("token")}`
			: "",
	};
	return config;
});

api.interceptors.response.use(
	response => responseInterceptor(response),
	error => errorInterceptor(error),
);

identityApi.interceptors.response.use(
	response => responseInterceptor(response),
	error => errorInterceptor(error),
);

export const responseInterceptor = response => {
	if (
		(response && response?.data && response.data?.status === 500) ||
		response.data.respcode
	) {
		if (response.data.message) {
			AlertService.alert("error", response.data.message);
		} else {
			AlertService.alert("error", "Sorry, something went wrong!");
		}
	} else if (response && response?.data && response.data?.status === 404) {
		// window.close();
	} else if (
		(response && response?.data && response?.data?.errors) ||
		response?.errors
	) {
		const errors = response.data?.errors || response?.errors;
		Object.entries(errors).forEach(([key, value]) => {
			if (key === "LogoutException") {
				logout();
			}
			if (Array.isArray(value)) {
				value.forEach(error => {
					if (error.params.Message) {
						showError(error.params.Message);
					} else if (error.message) {
						showError(error.message);
					} else if (error.key && error.params && error.params[error.key]) {
						showError(error.params[error.key]);
					}
				});
			}
		});
	}

	if (response && response.data) {
		return !response.data.respcode
			? response.data
			: new Error("Bad response from server");
	}

	// if (response && response.data) {
	// 	return !response.data.respcode
	// 		? response.data
	// 		: Promise.reject({
	// 				respmess: response.data.respmess,
	// 				respcode: response.data.respcode,
	// 		  });
	// }
};

const errorInterceptor = error => {
	if (error.response && error.response.status === 404) {
		window.location = "/";
		localStorage.clear();
	}
	if (error.response && error.response.status === 401) {
		const refreshToken = localStorage.getItem("refreshToken");
		const token = localStorage.getItem("token");
		if (!refreshToken || !token) {
			logout();
		} else {
			getUserDataByRefreshToken(refreshToken);
		}
		return false;
	}
	if (error.response && error.response.status === 500) {
		AlertService.alert("error", "Sorry, something went wrong!");
	}
	if (error.response) {
		const errors = error.response.data.errors;
		return Promise.reject(errors || error.response.data.ExcMessage || error);
	}
	if (error.response) {
		const errors = error.response.data.errors;

		return Promise.reject(errors || error.response.data.ExcMessage || error);
	} else {
		return Promise.reject(error);
	}
};

const showError = errorMsg => {
	errorMsg && AlertService.alert(ERROR_KEY, errorMsg);
};

const logout = () => {
	window.location.href = "/logout";
};

const getUserDataByRefreshToken = refreshToken => {
	if (isRefreshing) {
		return false;
	}
	isRefreshing = true;
	// const { user } = store.getState().user;

	MainService.callApi({
		api: ApiService.accountRefreshToken,
		data: refreshToken,
		cb: response => {
			if (!response.success) {
				logout();
			}
			if (response.data && response.data && response.data.accessToken) {
				const data = { ...response.data };
				store.dispatch(setToken(data));
				window.location.reload();
			} else {
			}
		},
		getFail: () => {
			logout();
		},
		_finally: () => {
			isRefreshing = false;
		},
	});
};

class ApiService {
	//user
	static accountLogin(data) {
		return identityApi.post(`/account/login`, data);
	}

	static accountRefreshToken(refreshToken) {
		return identityApi(`/account/refreshToken?refreshToken=${refreshToken}`);
	}

	//----

	//#region Network & Url
	static getNetworkPlatforms() {
		return api.get(`networkPlatform/getAll`);
	}
	static createNetworkPlatform(data) {
		return api.post(`networkPlatform/create`, data);
	}
	static updateNetworkPlatform(data) {
		return api.put(`networkPlatform/update`, data);
	}
	static getNetworkPlatformByid(id) {
		return api.get(`NetworkPlatform/get?id=${id}`);
	}
	static getNetworkTypes() {
		return api.get(`networkPlatform/getNetworkTypes`);
	}
	static deleteNetworkPlatform(id) {
		return api.delete(`networkPlatform/delete?id=${id}`);
	}
	static getUrlTypes() {
		return api.get(`url/getUrlType`);
	}
	static getUrlNames() {
		return api.get(`url/getUrlName`);
	}
	static deleteUrl(id) {
		return api.delete(`url/delete?id=${id}`);
	}
	static createUrl(data) {
		return api.post(`url/create`, data);
	}
	static updateUrl(data) {
		return api.put(`url/update`, data);
	}
	//#endregion

	//#region CryptoInfo
	static getTopCoins(data) {
		return api.post(`cryptoCurrency/getTopCoin`, data);
	}
	static getCoin(symbol) {
		return api.get(`cryptoCurrency/getCoin?symbol=${symbol}`);
	}
	static getDepth(data) {
		return api.post(`cryptoCurrency/getDepth`, data);
	}
	//#endregion

	//#region Scanner
	static checkAddressAllNetworks(address) {
		return api.get(`scanner/checkAddressAllNetworks?address=${address}`);
	}
	static getRegularTransactionsAddress(address, name) {
		return api.post(
			`scanner/GetRegularTransactionsAddress?address=${address}&name=${name}`,
		);
	}
	static getAddressBalance(address, chainId) {
		return api.post(
			`scanner/GetAddressBalance?address=${address}&chainId=${chainId}`,
		);
	}
	static checkTransaction(hash, chainId) {
		return api.post(`scanner/CheckTransaction?hash=${hash}&chainId=${chainId}`);
	}
	//#endregion

	//#region ChainConfig
	static getAllChainConfig() {
		return api.get(`chainConfig/GetAll`);
	}
	static getChainConfig(id) {
		return api.get(`chainConfig/Get?id=${id}`);
	}
	static createChainConfig(data) {
		return api.post(`chainConfig/Create`, data);
	}
	static updateChainConfig(data) {
		return api.put(`chainConfig/Update`, data);
	}
	static deleteChainConfig(id) {
		return api.delete(`chainConfig/Delete?id=${id}`);
	}
	//#endregion
	//Wallet Merchants
	static walletGetAllMerchants(pagination) {
		return api.post(`wallet/getAllMerchants`, pagination);
	}

	static walletGetWalletBalance(walletId) {
		return api.get(`wallet/getWalletBalance?walletId=${walletId}`);
	}

	static getSystemWallets() {
		return api.get(`/wallet/getSystemWallets`);
	}
	//end Wallet Merchants

	//Config

	static configGetAll() {
		return api.get(`/config/getAll`);
	}

	static configCreate(data) {
		return api.post(`/Config/Create`, data);
	}

	static configUpdate(data) {
		return api.put(`/Config/Update`, data);
	}

	static configDelete(id) {
		return api.delete(`/Config/Delete?id=${id}`);
	}

	//-----

	//Notification

	static notificationGetAll({ isNew, pagination }) {
		return api.post(`/Notification/GetAll?isNew=${isNew}`, pagination);
	}

	static notificationUpdate(id) {
		return api.put(`/notification/Update?id=${id}`);
	}

	//------

	//Transaction
	static transactionGetAll(pagination) {
		return api.post(`/Transaction/GetAll`, pagination);
	}

	static transactionReplenishingTheMerchantBalance(merchantId) {
		return api.get(
			`/transaction/replenishingTheMerchantBalance?merchantId=${merchantId}`,
		);
	}
	//

	//Merchant
	static merchantGetAll(pagination) {
		return api.post(`/merchant/getAllMerchants`, pagination);
	}
	//-----
}

export default ApiService;
